import { AiEvaluationQuestion } from 'api/administration/lessons/aiEvaluation'

let idCounter = 0

export const newClientId = (): string => {
  idCounter += 1
  return `ai-q-${Date.now()}-${idCounter}`
}

export const withClientIds = (
  questions: AiEvaluationQuestion[]
): AiEvaluationQuestion[] =>
  questions.map((q) => ({
    ...q,
    clientId: q.clientId || newClientId(),
  }))

export const validateQuestions = (
  questions: AiEvaluationQuestion[]
): string | null => {
  if (!questions.length) {
    return 'empty'
  }
  for (const q of questions) {
    if (!q.name?.trim()) return 'invalid'
    if (q.options.length !== 4) return 'invalid'
    if (!q.options.some((o) => o.correct)) return 'invalid'
    if (q.options.some((o) => !o.label?.trim())) return 'invalid'
  }
  return null
}

export const reorderQuestions = (
  questions: AiEvaluationQuestion[]
): AiEvaluationQuestion[] =>
  questions.map((q, idx) => ({ ...q, order: idx + 1 }))

export interface BlockQuestionGroup {
  blockIndex: number
  blockTitle: string
  questions: AiEvaluationQuestion[]
}

/** Agrupa preguntas por bloque de origen, preservando el orden de aparición. */
export const groupQuestionsByBlock = (
  questions: AiEvaluationQuestion[]
): BlockQuestionGroup[] => {
  const groups: BlockQuestionGroup[] = []
  const indexByBlock = new Map<number, number>()

  questions.forEach((question) => {
    const blockIndex = question.sourceBlockIndex ?? 0
    let groupIdx = indexByBlock.get(blockIndex)

    if (groupIdx === undefined) {
      groupIdx = groups.length
      indexByBlock.set(blockIndex, groupIdx)
      groups.push({
        blockIndex,
        blockTitle: question.sourceBlockTitle || '',
        questions: [],
      })
    }

    const group = groups[groupIdx]
    if (!group.blockTitle && question.sourceBlockTitle) {
      group.blockTitle = question.sourceBlockTitle
    }
    group.questions.push(question)
  })

  return groups
}
